import { TagsManagerGridController } from '../controller/TagsManagerGridController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class TagsManagerGridWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: TagsManagerGridController,
    });
  }

  public async reload(resetSelectionStore = false, forceResetSelectionStore = false) {
    await this.controller?.view.dom.$grid.controller.handleGridItemsLoad(resetSelectionStore, forceResetSelectionStore);
  }
}
